exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-w[data-v-78dc52ec]{width:300px}", ""]);

// exports
